<template>
    <configurazioni-component :pathResources="pathResources" :menuRoot="menuRoot"></configurazioni-component>
</template>

<script>
import ConfigurazioniComponent from "../components/ConfigurazioniComponent.vue";
export default {
    components: { ConfigurazioniComponent },
    data() {
        return {
            pathResources: "/vocimenu/configurazioni/configurazioni",
            menuRoot: "configurazioni",
        };
    },
};
</script>

<style></style>
